import CookieStorage from '../Storage/CookieStorage';
import ListrakBase from './ListrakBase';
import { ListrakAnalyticI, ApplyProductsRequest } from './types';

export default class ListrakAnalytic extends ListrakBase implements ListrakAnalyticI {
  constructor(protected cookies: CookieStorage) {
    super(cookies);
  }

  public async applyProducts(request: ApplyProductsRequest) {
    try {
      const { products, total } = request;

      const listrak = this.getListrak();

      if (listrak) {
        const orderKey = (await this.getOrderKey()) || 'orderKey';

        if (products?.length === 0) return listrak.SCA.ClearCart();
        products?.forEach((product) => {
          if (product) {
            listrak.SCA.AddItemWithLinks(
              product.id,
              product.quantity,
              product.price.toString(),
              product.name,
              product.image,
              product.productUrl,
            );
          }
        });

        listrak.SCA.Meta1 = orderKey;
        listrak.SCA.Meta2 = total;

        listrak.SCA.Submit();
      } else {
        console.warn('No Listrak was provided');
      }
    } catch (error) {
      console.log('can not apply products to listrak', error);
    }
  }

  public async addItemWithLinks(
    sku: string,
    pQuantity: number,
    pPrice: string,
    productPageName: string,
    _: string,
    pCanonical: string,
  ): Promise<void> {
    try {
      const listrak = this.getListrak();
      if (listrak) {
        listrak.SCA.AddItemWithLinks(sku, pQuantity, pPrice, productPageName, _, pCanonical);
      }
    } catch (error) {
      console.log('can not add item to listrak add to cart', error);
    }
  }

  public submitListrak(): void {
    try {
      const listrak = this.getListrak();
      if (listrak) {
        listrak.SCA.Submit();
      }
    } catch (error) {
      console.log('can not submit listrak', error);
    }
  }

  public async pageBrowseSubmit(sku: string): Promise<void> {
    try {
      const listrak = this.getListrak();
      if (listrak) {
        listrak?.Activity?.AddPageBrowse(sku);
        listrak?.Activity?.Submit();
      }
    } catch (error) {
      console.log('can not submit listrak activity', error);
    }
  }

  public async productBrowseSubmit(sku: string): Promise<void> {
    try {
      const listrak = this.getListrak();
      if (listrak) {
        listrak?.Activity?.AddProductBrowse(sku);
        listrak?.Activity?.Submit();
      }
    } catch (error) {
      console.log('can not submit Product Browse to listrak', error);
    }
  }

  public async listrakNotification(sku: string, email: string): Promise<void> {
    try {
      const listrak = this.getListrak();
      if (listrak) {
        listrak.Activity?.AddProductBrowse(sku);
        listrak.SCA.CaptureEmail(email);
      }
    } catch (error) {
      console.log('can not submit listrak notification:', error);
    }
  }
}
